import Toolbar from '@mui/material/Toolbar'
import { UrlParamFilteredSearchBar } from '../../common/Filters/FilterView/FilteredSearchBar'
import { FilterBy, FilterTemplate } from '../../common/Filters/FilterView/FilterTemplate'
import { AdBreaksRequestParams } from '../../../api/nm-types'
import { format } from 'date-fns'
import { DATE_FORMAT_LONGER, sentenceCase } from 'common/api/v1/helpers'
import { dateFilterPossibleValues } from '../../common/Filters/FilterView/dateFilter'
import Box from '@mui/material/Box'
import { AdBreakStatus } from 'common/api/v1/types'

const CommonActions = () => {
  const filters = makeAdBreakFilters()
  return (
    <Toolbar disableGutters style={{ overflowX: 'clip' }}>
      <Box sx={{ width: '100%' }}>
        <UrlParamFilteredSearchBar
          urlParamCacheKey={'adBreaks'}
          mapFilterToUrlParamFn={mapAdBreakFilterToUrlParam}
          mapUrlParamToFilterFn={mapUrlParamToAdBreakFilter}
          searchTokenFilters={filters}
          rawTextFilter={filters.find((f) => f.key === AdBreakFilterKey.timestamp)!}
        />
      </Box>
    </Toolbar>
  )
}

enum AdBreakFilterKey {
  timestamp = 'timestamp',
  status = 'status',
}

function mapAdBreakFilterToUrlParam(filter: FilterBy): Partial<AdBreaksRequestParams> {
  if ('value' in filter) {
    switch (filter.key) {
      case AdBreakFilterKey.timestamp:
        return filter.operator === 'after'
          ? { fromDate: new Date(filter.value).toISOString() }
          : { toDate: new Date(filter.value).toISOString() }
      case AdBreakFilterKey.status:
        return { status: filter.value as AdBreakStatus }
    }
  }
  return {}
}

function mapUrlParamToAdBreakFilter(key: keyof AdBreaksRequestParams, value: string): FilterBy | undefined {
  switch (key) {
    case 'fromDate':
      return {
        key: AdBreakFilterKey.timestamp,
        operator: 'after',
        value: format(new Date(value), DATE_FORMAT_LONGER),
      }
    case 'toDate':
      return {
        key: AdBreakFilterKey.timestamp,
        operator: 'before',
        value: format(new Date(value), DATE_FORMAT_LONGER),
      }
    case 'status':
      return {
        key: AdBreakFilterKey.status,
        operator: 'is',
        value: value as AdBreakStatus,
        displayName: sentenceCase(value),
      }
  }
  return undefined
}

function makeAdBreakFilters(): FilterTemplate[] {
  const filterTemplates: FilterTemplate[] = [
    {
      key: AdBreakFilterKey.timestamp,
      operator: 'after',
      possibleValuesSync: (s) => dateFilterPossibleValues(s),
    },
    {
      key: AdBreakFilterKey.timestamp,
      operator: 'before',
      possibleValuesSync: (s) => dateFilterPossibleValues(s),
    },
    {
      key: AdBreakFilterKey.status,
      operator: 'is',
      possibleValuesSync: () =>
        Object.values(AdBreakStatus).map((status) => ({
          value: status,
          displayName: sentenceCase(status),
        })),
    },
  ]
  return filterTemplates.sort((a, b) => a.key.localeCompare(b.key))
}

export default CommonActions
